import type { AppRouteObject } from "../routes";
import { LastLoginListingRoute } from "./routes/LastLoginListingRoute";

const routes: AppRouteObject[] = [LastLoginListingRoute];

export default routes;
